import React from "react";
import { Link } from "react-router-dom";
import img from "../../../images/error404.png";

const PageNotFound = ({items}) => {
    
  return (
    <div className="flex flex-col items-center h-fit bg-white p-2 pt-6">
      <img src={img} alt="404 Not Found" className="w-80 mb-1" />
      <h1 className="text-3xl font-bold text-gray-800 mb-2">Oops! This {items} is Unavailable</h1>
      <p className="text-gray-600 mb-6 text-center">
      The {items} you’re looking for might be out of stock or discontinued.
      </p>
      <Link to="/" className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">
        Go Back Home
      </Link>
    </div>
  );
};

export default PageNotFound;